import { render } from "./SupportModal.vue?vue&type=template&id=5119c865&scoped=true"
import script from "./SupportModal.vue?vue&type=script&lang=js"
export * from "./SupportModal.vue?vue&type=script&lang=js"

import "./SupportModal.vue?vue&type=style&index=0&id=5119c865&scoped=true&lang=scss"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5119c865"]])

export default __exports__